<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-bullhorn</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassworkMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-clipboard-check</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclasspeopleMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-account-multiple</v-icon> Anggota
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassgradeMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassabsenMhs', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-check</v-icon> Absen
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0">
            <v-card
              flat
              class="black--text">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12" class="text-center" v-if="loading.profile">
                    <v-progress-circular
                      :width="3"
                      color="red"
                      indeterminate>
                    </v-progress-circular>
                  </v-col>
                  <v-col cols="12" sm="10" v-if="!loading.profile && dataprofile.length > 0">
                    <div class="d-flex">
                      <div class="d-inline mr-5">
                        <v-img
                          :lazy-src="require('../../assets/default.jpg')"
                          max-height="70"
                          max-width="70"
                          :src="dataprofile[0].urlpic ? dataprofile[0].urlpic : ''">
                        </v-img>
                      </div>
                      <div class="d-inline">
                        <h2 class="text-md-h5 font-weight-bold">
                          {{ dataprofile[0].user_firstname }} {{ dataprofile[0].user_lastname }}
                        </h2>
                        <span class="text-subtitle-1">
                          NIM. {{ dataprofile[0].user_no ? dataprofile[0].user_no : '00'}}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="2" v-if="!loading.nilai && datanilai">
                    <div class="text-md-h5 font-weight-bold primary--text">
                      {{ datanilai.avggrade }}
                    </div>
                    <div class="text-subtitle-1">
                      Rata-rata
                    </div>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-progress-circular
                      v-if="loading.nilai"
                      :width="3"
                      color="red"
                      indeterminate>
                    </v-progress-circular>
                    <v-simple-table
                      v-if="!loading.nilai && datanilai">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>
                              Tugas
                            </th>
                            <th>
                              Batas Pengumpulan
                            </th>
                            <th>
                              Nilai
                            </th>
                            <th>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in datanilai.post"
                            :key="item.idpost">
                            <td>
                              <span
                                class="d-inline-block text-truncate text-no-wrap"
                                style="max-width: 250px;"
                                :title="item.title">
                                {{ item.title }}
                              </span>
                            </td>
                            <td class="text-no-wrap">
                              {{ item.duedate }}
                            </td>
                            <td class="text-no-wrap">
                              {{ item.idans === 0 ? 'missing' : item.nilai }}
                            </td>
                            <td>
                              <router-link
                                exact
                                class="text-decoration-none"
                                :to="{ name: 'DetailtugaskumpulMhs', query: { post: item.idpost, class: detaildata[0].id_class } }">
                                View details
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'ListclassMhs' }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Daftar kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'DetailclassgradeMhs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
      profile: false,
      nilai: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    detaildata: [],
    teacherlist: [],
    studentlist: [],
    dataprofile: [],
    datanilai: [],
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      mhs: false,
    },
    dmodaldata: {
      mhs: null,
    },
    msgcopy: '',
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
      this.getClass();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class) {
        this.axios
          .get(
            this.api + '/api/kelas/student/' + this.check.class,
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getProfile();
                this.getNilai();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Kelas tidak ditemukan!';
      }
    },
    getProfile() {
      if (this.tokenscr) {
        this.loading.profile = true;
        this.axios
          .get(
            this.api + '/api/user/profile',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dataprofile = resdata.data;
                if (resdata.data[0].st_pic) {
                  this.dataprofile[0].urlpic = this.api + '/upload/avatar/' + resdata.data[0].st_pic;
                } else {
                  this.dataprofile[0].urlpic = '';
                }
              }
            }
            this.loading.profile = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.profile = false;
          });
      }
    },
    getNilai() {
      if (this.tokenscr) {
        this.loading.nilai = true;
        this.axios
          .get(
            this.api + '/api/kelas/nilai/student/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datanilai = resdata.data;
              }
            }
            this.loading.nilai = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.nilai = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
